import { useAppContext } from '../store/appContext';
import { addTrailingSlash } from '../server/helpers/url';

export const useUrlBuilder = () => {
  const appContext = useAppContext();

  const localized = (url = '/'): string => {
    if (appContext === undefined || appContext.countryCode === undefined) {
      return `/us${url}`;
    }
    return `/${appContext.countryCode.toLowerCase()}${url}`;
  };

  const withCDN = (url: string): string => {
    if (appContext === undefined) {
      return `${url}`;
    }
    return `${appContext.s3BasePath}${url}`;
  };

  const withDomain = (url = ''): string => {
    if (appContext === undefined) {
      return `${url}`;
    }
    return `${appContext.paths.web.slice(0, -1)}${url}`;
  };

  const withTrailingSlash = (url: string): string => {
    return addTrailingSlash(url);
  };

  return {
    localized,
    withCDN,
    withDomain,
    withTrailingSlash,
  };
};
